import { create } from 'zustand'

interface SyncState {
  isSyncing: boolean
  syncComplete: boolean
  setSyncing: (v: boolean) => void
  setSyncComplete: () => void
  dismissSync: () => void
}

export const useSyncStore = create<SyncState>()((set) => ({
  isSyncing: false,
  syncComplete: false,
  setSyncing: (v) => set({ isSyncing: v }),
  setSyncComplete: () => set({ isSyncing: false, syncComplete: true }),
  dismissSync: () => set({ isSyncing: false, syncComplete: false }),
}))
